function initiateMediumSticky(elem) {
  return new Foundation.Sticky(elem, {
    stickTo: 'top',
    stickyOn: 'medium',
    marginTop: 0,
    anchor: 'page-sticky-anchor',
    container: elem.parent(),
  });
}

$(document).on('turbo:load', () => {
  const supportsSticky = CSS.supports('position', 'sticky');
  if (supportsSticky) return;

  const mediumStickyBits = $('.js-sticky-fallback-medium');
  if (!mediumStickyBits.length) return;

  mediumStickyBits.each(function () {
    initiateMediumSticky($(this));
  });

  $(window).trigger('load.zf.sticky');
});
